import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React from "react";

import TagsListWithSwitchersAbstract from "../../../../../abstract/TagsListWithSwitchersAbstract";
import withAllTagsList from "../../../../../hocs/withAllTagsList";
import TagsHelper from "../../../../../lib/TagsHelper/TagsHelper";

@withAllTagsList
class TagsList extends TagsListWithSwitchersAbstract {
  render() {
    const {
      allTags: { loading, data },
      translate,
      ticker
    } = this.props;

    return (
      <div>
        {loading ? (
          <div className="text-center">
            <i className="fal fa-spinner fa-spin" />
          </div>
        ) : null}
        {data.length
          ? data
              .filter(tag => TagsHelper.isUserTag(tag))
              .map(tag => {
                const tagIsActive = this.getTagIsActive(tag);

                return (
                  <FormControlLabel
                    key={tag.id}
                    className={"checkbox-wrapper"}
                    classes={{
                      label: "checkbox-label-wrapper"
                    }}
                    control={
                      <Checkbox
                        checked={tagIsActive}
                        onChange={() => {
                          this.onTagChange(tag, ticker);
                        }}
                        disabled={tag.is_admin_tag}
                      />
                    }
                    label={<span className={"checkbox-label"}>{tag.name}</span>}
                  />
                );
              })
          : null}
        {!loading && !data.length ? (
          <div className="no-tags-notice">
            {translate(
              "You have no tags. Create one using second tab in this view."
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default TagsList;
